
export type MessagingGetChatRoomById200LastMessageBasicInfoAllOfTwoType = typeof MessagingGetChatRoomById200LastMessageBasicInfoAllOfTwoType[keyof typeof MessagingGetChatRoomById200LastMessageBasicInfoAllOfTwoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MessagingGetChatRoomById200LastMessageBasicInfoAllOfTwoType = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  FILE: 'FILE',
  LINK: 'LINK',
} as const;
